import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text, Tooltip, getPaletteColor, Box, Flex } from 'pcln-design-system'
import { AmenityIcon } from '@pcln/fly-ui-components'
import index from '../../util/get-included-amenities'
import { cabinClassMap } from '../../constants'

const StyledUpsellNotice = styled(Text)`
  vertical-align: middle;
  color: ${getPaletteColor('text.base')};
  padding-top: 0px;
  font-size: 12px;
  line-height: 16px;
  ${(props) => props.hasIcons && 'margin-top: 2px;'};
`

const CapitalizeSpan = styled(Text.span)`
  text-transform: capitalize;
`

// PCLN Design System "Box" is throwing warnings and wants us to use Text.p instead
const IconWrapper = styled.div`
  padding: 0;
  display: none;
  height: 20px;
  margin-right: 4px;
  vertical-align: middle;
  overflow: hidden;
  ${(props) => props.theme.flyQueries.desktop} {
    display: inline-block;
  }
`

const allSameFareBrand = (fareBrands) =>
  fareBrands.every((fb) => fb && fb.toLowerCase() === fareBrands[0].toLowerCase())

const formatFareBrands = (fareBrands, isFused) =>
  !isFused || allSameFareBrand(fareBrands) ? [fareBrands[0]] : fareBrands

export default class UpsellNotice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isVisible: false,
    }

    this.toggleTooltip = this.toggleTooltip.bind(this)
  }

  toggleTooltip() {
    const isVisible = !this.state.isVisible
    this.setState({ isVisible })
  }

  render() {
    let { notice } = this.props
    const { fareBrandNames, isFused, searchRequestCabinClass } = this.props
    notice = notice.trim()
    const { isVisible } = this.state
    let noticeType = notice
    let noticeMessage = notice
    const endOfFirstSentence = notice.indexOf('.') + 1

    if (endOfFirstSentence > 0 && endOfFirstSentence < notice.length) {
      noticeType = notice.slice(0, endOfFirstSentence).trim()
      noticeMessage = notice.slice(endOfFirstSentence).trim()
    }

    const includedAmenities = index(notice)

    noticeType = includedAmenities.carryOnBag && includedAmenities.seatSelection ? '' : 'Basic Fare'

    const basicEconomyIcons = (
      <IconWrapper className='upsell-notice-icons-container'>
        <Flex>
          <Box data-testid={'bag-icon'}>
            <AmenityIcon name={'bag'} included={includedAmenities.carryOnBag} />
          </Box>
          <Box data-testid={'seat-icon'}>
            <AmenityIcon name={'seat'} included={includedAmenities.seatSelection} />
          </Box>
        </Flex>
      </IconWrapper>
    )

    const tooltip = isVisible && (
      <Tooltip left top bg='text.base' color='background.lightest' data-test='strike-through-tooltip'>
        {noticeMessage}
      </Tooltip>
    )

    return (
      <StyledUpsellNotice
        data-testid='upsell-notice'
        hasIcons={!!basicEconomyIcons}
        onMouseOver={this.toggleTooltip}
        onMouseOut={this.toggleTooltip}
      >
        {tooltip}
        {basicEconomyIcons}
        <CapitalizeSpan regular>
          {fareBrandNames.length
            ? formatFareBrands(fareBrandNames, isFused)
                .map((fb) => fb || cabinClassMap[searchRequestCabinClass])
                .join(', ')
            : noticeType}
        </CapitalizeSpan>
      </StyledUpsellNotice>
    )
  }
}

UpsellNotice.propTypes = {
  notice: PropTypes.string.isRequired,
  isFused: PropTypes.bool,
  fareBrandNames: PropTypes.array,
  searchRequestCabinClass: PropTypes.string,
  fareBrandAttributes: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      inclusion: PropTypes.string,
      type: PropTypes.string,
    })
  ),
}

UpsellNotice.defaultProps = {
  notice: '',
  fareBrandNames: [],
}

UpsellNotice.contextTypes = {
  SETI: PropTypes.object,
}
